import {
  SessionData,
  ClientSession as OldClientSession,
} from 'shared/utils/auth/v2/utils'
import type { ClientSession } from './types'

export const isSessionValid = (session: ClientSession | null): boolean => {
  if (!session) return false
  return session.expiration > Date.now()
}

export const isSessionCloseToExpiring = (
  session: ClientSession | null,
  bufferMs: number = 30000,
): boolean => {
  if (!session) return false
  return session.expiration - Date.now() <= bufferMs
}

export function toSessionData(
  session: ClientSession | OldClientSession | SessionData | null | undefined,
): ClientSession | null {
  if (!session?.accessToken || !session.member?.id) return null

  return {
    version: session.version,
    expiration: session.expiration,
    accessToken: session.accessToken,
    member: session.member,
    workspace: session.workspace,
    _impersonated:
      '_impersonated' in session ? Boolean(session._impersonated) : false,
    ...('_hash' in session && session._hash ? { _hash: session._hash } : {}),
  }
}

export function mergeSessionData(
  existingSession: ClientSession | null,
  newSession: ClientSession,
): ClientSession {
  if (!existingSession) {
    return newSession
  }

  return {
    version: newSession.version,
    expiration: newSession.expiration,
    accessToken: newSession.accessToken,
    member: newSession.member,
    workspace: newSession.workspace ?? existingSession.workspace,
    _hash: newSession._hash ?? existingSession._hash,
    _impersonated: newSession._impersonated ?? existingSession._impersonated,
  }
}

export function hasCompleteUserData(session: ClientSession | null): boolean {
  return !!(session?.accessToken && session.member?.id && session.member?.role)
}
